import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AppComponent } from '../../app.component';
import { AppMainComponent } from '../../app.main.component';
import { UserService } from 'src/app/core/services/user.service';
import { Evento, EventoMenu } from 'src/app/sigeve/evento/models/evento';
import { Observable } from 'rxjs';
import { EventoService } from 'src/app/sigeve/evento/evento.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    animations: [
        trigger('inline', [
            state('hidden', style({
                height: '0px',
                overflow: 'hidden'
            })),
            state('visible', style({
                height: '*',
            })),
            state('hiddenAnimated', style({
                height: '0px',
                overflow: 'hidden'
            })),
            state('visibleAnimated', style({
                height: '*',
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppMenuComponent implements OnInit {

    model: any[];
    eventos$: Observable<EventoMenu>;
    eventos: Evento[];
    items:any[];

    constructor(public app: AppComponent, public appMain: AppMainComponent, private userService: UserService, private eventoService: EventoService) { 

        //this.eventos$ = this.eventoService.getEventosAbertosMenu();
    }

    ngOnInit() {

        if(this.userService.getRoles().includes('P_SUPER_ADMIN')|| this.userService.getRoles().includes('P_ADMIN')){
            this.items=[{label: 'Evento', icon: 'pi pi-fw pi-calendar-plus', routerLink: ['/evento-list']} ]
        }
        this.setMenu(); 

        if(!this.userService.getRoles().includes('P_INVENTARIO') &&
        !this.userService.getRoles().includes('P_PRECIFICACAO')){
        this.eventoService.getEventosAbertos().subscribe(
            (res) => {
              if (res) {
                this.eventos = res;  
                this.eventos.forEach(element => {
                    if(element.flAtivo){
                        let k =  {label: 'Emitir Pedido '+element.nome, icon: 'pi pi-fw pi-plus', routerLink: ['/evento/'+element.idEvento+'/pedido']};
                        let l = {label: 'Pedidos '+element.nome, icon: 'pi pi-fw pi-check-square', routerLink: ['/evento/'+element.idEvento+'/pedido-list']}
                        
                        this.items.push(k);
                        this.items.push(l);
                    }else{
                        let l = {label: 'Pedidos '+element.nome, icon: 'pi pi-fw pi-check-square', routerLink: ['/evento/'+element.idEvento+'/pedido-list']}
                        
                        this.items.push(l);
                    }
                });
                this.setMenu();          
              }
            },
            err => {
              console.log("EventoList - Eventos");
              console.log(err);
              this.setMenu();
            }
          );
        }
    }

    setMenu(){

        if(this.userService.getRoles().includes('P_SUPER_ADMIN')){

            this.model = [
                /*{
                    label: 'Dashboard', icon: 'pi pi-fw pi-chart-bar',

                    items: [
                        {label: 'Dashboard Vendas', icon: 'pi pi-fw pi-chart-line', routerLink: ['/dashboard-evento-vendas/1']}
                        //{label: 'Dashboard Cliente', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/dashboard-evento-cliente']}                    
                    ]
                },*/
            {
                label: 'Pedidos', icon: 'pi pi-fw pi-home',
                items: [
                    {label: 'Pedidos Abertos', icon: 'pi pi-fw pi-home', routerLink: ['/']},
                    {label: 'Pedidos Comissão', icon: 'pi pi-fw pi-check-square', routerLink: ['/comissao-list']},
                    {label: 'Pedidos Encerrados', icon: 'pi pi-fw pi-check-square', routerLink: ['/pedidofechado']}                    
                ]
            },
            {
                label: 'Administração', icon: 'pi pi-fw pi-user',
                items: [
                    {label: 'Fluxo de Status', icon: 'pi pi-fw pi-ellipsis-h', routerLink: ['/statusfluxo']},
                    {label: 'Usuários', icon: 'pi pi-fw pi-users', routerLink: ['/usuario']}                    
                ]
            },
            {
                label: 'Cadastros', icon: 'pi pi-fw pi-cog',
                items: [
                    {label: 'Cidades', icon: 'pi pi-fw pi-map-marker', routerLink: ['/cidade-list']},
                    {label: 'Comissão', icon: 'pi pi-fw pi-dollar', routerLink: ['/comissao']},
                    {label: 'Comissão - Grupo', icon: 'pi pi-fw pi-money-bill', routerLink: ['/grupo-comissao']},
                    {label: 'Comissão - Tipo', icon: 'pi pi-fw pi-money-bill', routerLink: ['/tipo-comissao']},
                    {label: 'Descontos - Esc/Log', icon: 'pi pi-fw pi-dollar', routerLink: ['/desconto']},
                    {label: 'Descontos - Grupo', icon: 'pi pi-fw pi-money-bill', routerLink: ['/grupo-desconto']},
                    {label: 'Fornecedores', icon: 'pi pi-fw pi-money-bill', routerLink: ['/fornecedor-list']},
                    {label: 'Descontos Tipo Cliente', icon: 'pi pi-fw pi-th-large', routerLink: ['/atributos']},
                    {label: 'Juros', icon: 'pi pi-fw pi-th-large', routerLink: ['/pagamento-regra']},
                    {label: 'Produtos', icon: 'pi pi-fw pi-th-large', routerLink: ['/produto-list']},
                    {label: 'Produtos Estoque', icon: 'pi pi-fw pi-th-large', routerLink: ['/produto-estoque-list']},
                    {label: 'Parametrização', icon: 'pi pi-fw pi-th-large', routerLink: ['/parametrizacao']}
                ]
            },
            {
                label: 'Precificação', icon: 'pi pi-fw pi-dollar',
                items: [
                    {label: 'Nova Precificação', icon: 'pi pi-fw pi-dollar', routerLink: ['/precificacao-criar']},
                ]
            },
            {
                label: 'Eventos', icon: 'pi pi-fw pi-calendar',
                items: this.items//[
                   // {label: 'Evento', icon: 'pi pi-fw pi-calendar-plus', routerLink: ['/evento-list']},
                   // {label: 'Emitir Pedido', icon: 'pi pi-fw pi-plus', routerLink: ['/evento/1/pedido']},
                   // {label: 'Pedidos', icon: 'pi pi-fw pi-check-square', routerLink: ['/evento/1/pedido-list']},
                    /*{label: 'Comissão', icon: 'pi pi-fw pi-money-bill', routerLink: ['/evento-detalhe']},
                    {label: 'Pedidos', icon: 'pi pi-fw pi-dollar', routerLink: ['/evento-list']},                    
                    {label: 'Produtos', icon: 'pi pi-fw pi-th-large', routerLink: ['/evento-list']}*/
                //]
            },
            {
                label: 'Inventario', icon: 'pi pi-fw pi-shopping-cart',
                items: [
                    {label: 'Inventario', icon: 'pi pi-fw pi-ellipsis-h', routerLink: ['/inventario']}                 
                ]
            },
            
                {label: 'Produtos Estoque', icon: 'pi pi-fw pi-th-large', routerLink: ['/produto-estoque-list']},
            
        ];
    }else 
    
    if(this.userService.getRoles().includes('P_INVENTARIO')){

        this.model = [
           
        {
            label: 'Inventario', icon: 'pi pi-fw pi-shopping-cart',
            items: [
                {label: 'Inventario', icon: 'pi pi-fw pi-ellipsis-h', routerLink: ['/inventario']}                 
            ]
        },
        
    ];
}else     if(this.userService.getRoles().includes('P_PRECIFICACAO')){

    this.model = [
       
        {
            label: 'Precificação', icon: 'pi pi-fw pi-dollar',
            items: [
                {label: 'Nova Precificação', icon: 'pi pi-fw pi-dollar', routerLink: ['/precificacao-criar']},
            ]
        },
    
];
}else 
    
    
    if(this.userService.getRoles().includes('P_ADMIN')){

        this.model = [
            /*{
                label: 'Dashboard', icon: 'pi pi-fw pi-chart-bar',
                items: [
                    {label: 'Dashboard Vendas', icon: 'pi pi-fw pi-chart-line', routerLink: ['/dashboard-evento-vendas/1']}
                    //{label: 'Dashboard Cliente', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/dashboard-evento-cliente']}                    
                ]
            },*/
        {
            label: 'Pedidos', icon: 'pi pi-fw pi-home',
            items: [
                {label: 'Pedidos Abertos', icon: 'pi pi-fw pi-home', routerLink: ['/']},
                {label: 'Pedidos Comissão', icon: 'pi pi-fw pi-check-square', routerLink: ['/comissao-list']},
                {label: 'Pedidos Encerrados', icon: 'pi pi-fw pi-check-square', routerLink: ['/pedidofechado']}                    
            ]
        },
        {
            label: 'Administração', icon: 'pi pi-fw pi-user',
            items: [
                {label: 'Fluxo de Status', icon: 'pi pi-fw pi-ellipsis-h', routerLink: ['/statusfluxo']}                
            ]
        },
        {
            label: 'Cadastros', icon: 'pi pi-fw pi-cog',
            items: [
                {label: 'Cidades', icon: 'pi pi-fw pi-map-marker', routerLink: ['/cidade-list']},
                {label: 'Comissão', icon: 'pi pi-fw pi-dollar', routerLink: ['/comissao']},
                {label: 'Comissão - Grupo', icon: 'pi pi-fw pi-money-bill', routerLink: ['/grupo-comissao']},
                {label: 'Comissão - Tipo', icon: 'pi pi-fw pi-money-bill', routerLink: ['/tipo-comissao']},
                {label: 'Descontos - Esc/Log', icon: 'pi pi-fw pi-dollar', routerLink: ['/desconto']},
                {label: 'Descontos - Grupo', icon: 'pi pi-fw pi-money-bill', routerLink: ['/grupo-desconto']},
            ]
        },

        {
            label: 'Precificação', icon: 'pi pi-fw pi-dollar',
            items: [
                {label: 'Nova Precificação', icon: 'pi pi-fw pi-dollar', routerLink: ['/precificacao-criar']},
            ]
        },
        {
            label: 'Eventos', icon: 'pi pi-fw pi-calendar',
            items: this.items//[
               // {label: 'Evento', icon: 'pi pi-fw pi-calendar-plus', routerLink: ['/evento-list']},
                //{label: 'Emitir Pedido', icon: 'pi pi-fw pi-plus', routerLink: ['/evento/1/pedido']},
               // {label: 'Pedidos', icon: 'pi pi-fw pi-check-square', routerLink: ['/evento/1/pedido-list']},
                /*{label: 'Comissão', icon: 'pi pi-fw pi-money-bill', routerLink: ['/evento-detalhe']},
                {label: 'Pedidos', icon: 'pi pi-fw pi-dollar', routerLink: ['/evento-list']},                    
                {label: 'Produtos', icon: 'pi pi-fw pi-th-large', routerLink: ['/evento-list']}*/
            //]
        },
        {
            label: 'Inventario', icon: 'pi pi-fw pi-shopping-cart',
            items: [
                {label: 'Inventario', icon: 'pi pi-fw pi-ellipsis-h', routerLink: ['/inventario']}                 
            ]
        },
        
    ];
}else if(this.userService.getRoles().includes('P_FABRICA')){

                this.model = [
                {
                    label: 'Pedidos', icon: 'pi pi-fw pi-home',
                    items: [
                        {label: 'Pedidos Abertos', icon: 'pi pi-fw pi-home', routerLink: ['/']},
                        {label: 'Pedidos Comissão', icon: 'pi pi-fw pi-check-square', routerLink: ['/comissao-list']},
                        {label: 'Pedidos Encerrados', icon: 'pi pi-fw pi-check-square', routerLink: ['/pedidofechado']}                    
                    ]
                },
                
                
                {
                    label: 'Eventos', icon: 'pi pi-fw pi-calendar',
                    items: this.items
                  /*  items: [
                        
                        {label: 'Emitir Pedido', icon: 'pi pi-fw pi-plus', routerLink: ['/evento/1/pedido']},
                        {label: 'Pedidos', icon: 'pi pi-fw pi-check-square', routerLink: ['/evento/1/pedido-list']},

                    ]*/
                },
                
                ];
              
            } else if(this.userService.getRoles().includes('P_VENDEDOR')||this.userService.getRoles().includes('P_VENDEDOR_INTERNO')){

                this.model = [

                    {label: 'Produtos Estoque', icon: 'pi pi-fw pi-th-large', routerLink: ['/produto-estoque-list']},

    
                {
                    label: 'Eventos', icon: 'pi pi-fw pi-calendar',
                    /*items: [
                       
                        {label: 'Emitir Pedido', icon: 'pi pi-fw pi-plus', routerLink: ['/evento/1/pedido']},
                        {label: 'Pedidos', icon: 'pi pi-fw pi-check-square', routerLink: ['/evento/1/pedido-list']},
    
                    ]*/
                    items: this.items
                },
                
                ];
            } 





    }

    onMenuClick(event) {
        this.appMain.onMenuClick(event);
    }
}
